import { Phone, Mail, MapPin } from "lucide-react";
import { COMPANY } from "@/lib/data";

const links = [
  { href: "#services", label: "Services" },
  { href: "#faq", label: "FAQ" },
  { href: "#reservation", label: "Réserver" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-secondary text-white/80">
      <div className="container-x py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <img
              src={COMPANY.logo}
              alt={COMPANY.name}
              className="h-14 w-auto object-contain mb-4 brightness-0 invert"
            />
            <p className="max-w-md text-sm leading-relaxed">
              Service professionnel de lavage à pression résidentiel et commercial dans la région de {COMPANY.city}.
              Résultats impeccables.
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Liens rapides</h4>
            <ul className="space-y-3 text-sm">
              {links.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.href.replace("#", "")}`}
                    className="hover:text-primary transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Phone className="w-4 h-4 mt-0.5 text-primary" />
                <a href={`tel:${COMPANY.phoneRaw}`} className="hover:text-white" data-testid="footer-phone">
                  {COMPANY.phone}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="w-4 h-4 mt-0.5 text-primary" />
                <a href={`mailto:${COMPANY.email}`} className="hover:text-white break-all" data-testid="footer-email">
                  {COMPANY.email}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 text-primary" />
                <span>{COMPANY.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/60">
          <div>© {new Date().getFullYear()} {COMPANY.name}.</div>
          <div>Lavage à pression résidentiel et commercial • Québec</div>
        </div>
      </div>
    </footer>
  );
}
